"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
const commonTabs_1 = require("./commonTabs");
exports.CmsNav = ({ activeTab, cmsId }) => {
    return (react_1.default.createElement(reusables_1.NavPills, { activeTab: activeTab, center: true, queryDetailLayout: true, tabs: [
            ...commonTabs_1.commonLeftTabs(cmsId, 'ContentSystem'),
            {
                exact: false,
                id: 'content-feeds',
                name: 'Feeds',
                strict: false,
                to: `/integrations/${cmsId}/feeds`,
            },
            {
                id: 'content-mappings',
                name: 'Mappings',
                to: `/integrations/${cmsId}/mappings`,
            },
            {
                id: 'content-conversions',
                name: 'Conversions',
                to: `/integrations/${cmsId}/conversions`,
            },
            ...commonTabs_1.commonRightTabs(cmsId),
        ] }));
};
//# sourceMappingURL=CmsNav.js.map